/**
 * Release 3 D — guest experience. A member whose workspace-level mask carries no VIEW (the guest role, mask 0) sees only
 * the boards an override grants: the sidebar lists those subtrees, workspace-wide pages (people, duplicates, trash,
 * settings) stay hidden and search is limited server-side to the granted boards.
 */
import { useSessionStore } from '@/stores/session';
import { hasPermission } from '@/lib/shared';

export function useGuestMode(): boolean {
  return useSessionStore((s) => s.principal.kind === 'member' && !hasPermission(s.principal.mask, 'VIEW'));
}
